import {MutationTree} from "vuex";
import {WidgetState} from "../models/store-viewmodel";
import {Config} from "../models/config-viewmodel";

export default <MutationTree<WidgetState>>{
    setConfig(state, config: Config) {
        state.config = config
    },
    toggleModal(state, toggleModal: boolean) {
        state.toggle_modal = toggleModal
    }
}
